import styled from 'styled-components'

export default styled.h5`
  color: #008172;
  font-weight: 600;
  font-size: 24px;
`
